module.exports = __webpack_public_path__ + "img/vn.ed3249c2.svg";